import React, { Component } from 'react';

class ErrorText extends Component {

    render() {
        if (this.props.message) {
            return (
                <div className="d-flex align-items-center py-2">
                    <div className="preview-thumbnail" >
                        <h2 className="dis-error-text mdi mdi-alert-circle-outline" />
                    </div>
                    <div className="preview-item-content pl-3">
                        <h6 className="dis-error-text font-weight-normal">{this.props.message}</h6>
                    </div>
                </div>
            );
        }
        else
            return (<div/>);
    }
}


export default ErrorText;